import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import Button from '@deprecated-ui/common/Button';
import Iconmoon, { IconWrapper } from '@deprecated-ui/common/Iconmoon';
import color from '@deprecated-ui/_style/color';
import AuthCardLayout from 'global/AuthCardLayout';

interface NotifyVerificationProps {
  onContinue: () => void;
  type: 'phone' | 'email';
  recipient: string;
}

function NotifyVerification({
  onContinue,
  recipient,
  type,
}: NotifyVerificationProps) {
  const isPhone = type === 'phone';
  return (
    <AuthCardLayout>
      {/* @ts-expect-error */}
      <Flex justify="center" align="center" pt="40px">
        {/* @ts-expect-error */}
        <Text size="20px" family="light" pr="5px">
          {isPhone ? 'Check Your Phone Message' : 'Check Your Email Message'}
        </Text>
        <IconWrapper>
          <Iconmoon
            className="icon-toolbar_valid"
            size="24px"
            color={color.primary}
          />
        </IconWrapper>
      </Flex>
      {/* @ts-expect-error */}
      <Text align="center" pt="20px" color={color.dimgray}>
        {isPhone
          ? `A verification code has been sent to your phone: ${recipient}`
          : `A verification code has been sent to your email: ${recipient}`}
      </Text>
      <Flex justify="center">
        <Button
          onClick={onContinue}
          type="primary"
          // @ts-expect-error
          mt="20px"
          height="35px"
          round
          block
          id="verify-phone"
        >
          <Text color="light" size="16px" family="light">
            {isPhone ? 'Verify Phone Number' : 'Verify Email'}
          </Text>
        </Button>
      </Flex>
    </AuthCardLayout>
  );
}

export default NotifyVerification;
